import { db } from "@/firebase"

const projectsNotifyConfigs_ref = db.collection("projects_notify_configs")

export const setProjectNotifyConfig = async (franchiseeId, data) => {
  try {
    // Já recebemos no formato atual: { [id]: [...statuses] }
    const notification_receptors = data.notification_receptors ?? {}

    const receptorsCount = Object.keys(notification_receptors).length
    if (receptorsCount > 5) {
      throw new Error("Max 5 notification receptors allowed")
    }

    await projectsNotifyConfigs_ref
      .doc(franchiseeId)
      .set(
        {
          notification_receptors,
        },
      )

    return true
  } catch (error) {
    console.error("Error in setProjectNotifyConfig:", error);
    throw error;
  }
}

export const getProjectNotifyConfig = async (franchiseeId) => {
  try {
    const doc = await projectsNotifyConfigs_ref.doc(franchiseeId).get()
    if (!doc.exists) return null
    const data = doc.data()
    return data
  } catch (error) {
    console.error("Error in getProjectNotifyConfig:", error);
    throw error;
  }
}

export default { setProjectNotifyConfig, getProjectNotifyConfig }